import axios from "axios";

// export const apiUrl=`https://ke-glab.rashigames.com/`;
export const apiUrl=`/`;

export const getGamesApi=async()=>{
    const response=await axios.get(`${apiUrl}api/content/games`);
    return response;
}

export const getTokenApi=`${apiUrl}get-token`;

export const printLogsApi=`${apiUrl}print-logs/print`;

export const getHeaderEnrichmentApi=`https://sdp.tamaituk.com/api/v2/identity/getHeaderEnrichmentToken`;

export const getIPApi=`https://api.ipify.org?format=json`;

export const loginApi=`${apiUrl}api/login`;

export const subscribeApi=`${apiUrl}subscribe-user`;

export const deactivateApi=`${apiUrl}deactivate-user`;